import React, { useState } from 'react';
import { Trophy, Layers, ThumbsUp, Users } from 'lucide-react';
import { values } from '../../mockData';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';

const AboutSection = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Left Side */}
          <div>
            <div className="mb-8">
              <span className="text-yellow-500 font-semibold text-sm uppercase tracking-wider">ABOUT US</span>
              <h2 className="text-4xl font-bold text-gray-800 mt-2 mb-4">We deliver landmark projects</h2>
              <p className="text-gray-600 leading-relaxed">
               Aranvic is a multi-disciplinary engineering and manufacturing company offering product design, FEA/CFD analysis, precision fabrication, industrial instrumentation, and advanced battery refurbishment solutions.
We provide end-to-end services — from concept, design, and development to machining, fabrication, filtration systems, and industrial equipment manufacturing.
With strong technical expertise, quality standards, and innovative technology, Aranvic delivers reliable, cost-effective, and sustainable engineering solutions for multiple industries
              </p>
            </div>

            {/* Features Grid */}
            <div className="grid grid-cols-2 gap-6 mb-8">
              <div className="flex items-start gap-3">
                <Trophy className="text-yellow-500 flex-shrink-0" size={40} />
                <div>
                  <h3 className="font-bold text-gray-800 mb-1">We've Reputation for Excellence</h3>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Layers className="text-yellow-500 flex-shrink-0" size={40} />
                <div>
                  <h3 className="font-bold text-gray-800 mb-1">We Build Partnerships</h3>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <ThumbsUp className="text-yellow-500 flex-shrink-0" size={40} />
                <div>
                  <h3 className="font-bold text-gray-800 mb-1">Guided by Commitment</h3>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Users className="text-yellow-500 flex-shrink-0" size={40} />
                <div>
                  <h3 className="font-bold text-gray-800 mb-1">A Team of Professionals</h3>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side - Our Values */}
          <div>
            <div className="mb-8">
              <h2 className="text-4xl font-bold text-gray-800 mb-4">Our Values</h2>
              <p className="text-gray-600 leading-relaxed">
                We focus on long-term client relationships by offering tailored solutions, responsive support, and consistent performance.
              </p>
            </div>

            <Accordion type="single" collapsible className="space-y-3">
              {values.map((value, index) => (
                <AccordionItem key={value.id} value={`item-${index}`} className="border border-gray-200 bg-white">
                  <AccordionTrigger className="px-6 py-4 hover:no-underline hover:bg-yellow-50 transition-colors">
                    <span className="font-bold text-gray-800 uppercase">{value.title}</span>
                  </AccordionTrigger>
                  <AccordionContent className="px-6 pb-4">
                    <p className="text-gray-600">{value.description}</p>
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;